import { mapActions, mapGetters } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  props: {
    layout: {
      type: String,
      default: '',
    },
    marketId: {
      type: Number,
    },
    isWatched: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
      isOn: this.isWatched,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    classModifiers() {
      return {
        [`market-watch--${this.layout}`]: this.layout,
        'market-watch--on': this.isOn,
        'market-watch--off': !this.isOn,
      };
    },
    title() {
      return this.isOn ? 'Remove from Watchlist' : 'Add to Watchlist';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('profile', [
      'addMarketToWatchList',
      'removeMarketFromWatchList',
    ]),
    ...mapActions('watchlist', ['reloadWatchlist']),
    ...mapActions('browse', ['updateMarketNotWatched']),
    onWatchToggle() {
      if (!this.isLoggedIn) {
        this.setCurrentPopup(MODALS.LOGIN);
        return;
      }
      this.show = false;
      if (!this.isOn) {
        this.addMarketToWatchList(this.marketId)
          .then(() => {
            this.$emit('watchToggle', true);
            this.reloadWatchlist();
          });
      } else {
        this.removeMarketFromWatchList(this.marketId)
          .then(() => {
            this.$emit('watchToggle', false);
            this.reloadWatchlist();
            this.updateMarketNotWatched(this.marketId);
          });
      }
      this.isOn = !this.isOn;
      setTimeout(() => { this.show = true; }, 0);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-watch/market-watch.js